import { RestTypeConnection, StandardError, IEnvironment } from "ecloud-base-connector";

export abstract class MagentoEnv implements IEnvironment {
	public abstract readonly code: string;
	public abstract readonly name: string;

	protected readonly baseUrl: string;
	protected readonly apiKey: string;

	public constructor(baseUrl: string, apiKey: string) {
		this.baseUrl = baseUrl;
		this.apiKey = apiKey;
		return this;
	}

	validate() {
		if (
			!this.baseUrl ||
			!this.apiKey
		)
			throw new StandardError(null, `Missing environment variables for ${this.name} Magento environment`);
	}

	getConnection() {
		const baseHeaders = {};

		const defaultMaxRequestLimit = 50;
		const defaultPerMillisecondLimit = 100;

		const additionalHeaders = {
			Authorization: `Bearer ${this.apiKey}`
		};
		return new RestTypeConnection(
			this.baseUrl,
			baseHeaders,
			{
				additionalHeaders,
				maxRequestsLimit: defaultMaxRequestLimit,
				perMillisecondsLimit: defaultPerMillisecondLimit
			}
		);
	}
}

class EnvSelector {
	selectedEnv: MagentoEnv;
	initEnv(selectedEnv: MagentoEnv) {
		this.selectedEnv = selectedEnv;
	}
}

export const envSelector = new EnvSelector();